import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';

function TestimonialThree() {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Fetch testimonials data from API
    useEffect(() => {
        const fetchTestimonials = async () => {
            setLoading(true);
            try {
                const response = await fetch('https://dzsoftech.net/tours/api/airticket/testimonials/');
                if (!response.ok) {
                    throw new Error('Failed to fetch testimonials data');
                }
                const data = await response.json();
                
                if (data.results && data.results.length > 0) {
                    // Get active testimonials, prioritize featured ones
                    const activeTestimonials = data.results
                        .filter(testimonial => testimonial.is_active)
                        .sort((a, b) => {
                            if (a.featured && !b.featured) return -1;
                            if (!a.featured && b.featured) return 1;
                            return a.order - b.order;
                        });
                    setTestimonials(activeTestimonials);
                } else {
                    // Use fallback data if no testimonials
                    setTestimonials(getFallbackTestimonials());
                }
            } catch (err) {
                console.error('Error fetching testimonials:', err);
                setError(err.message);
                // Use fallback data on error
                setTestimonials(getFallbackTestimonials());
            } finally {
                setLoading(false);
            }
        };

        fetchTestimonials();
    }, []);

    // Fallback testimonials data if API fails
    const getFallbackTestimonials = () => {
        return [
            {
                id: 'fallback-1',
                customer_name: 'Andrew Simon',
                customer_title: 'Traveller',
                customer_image_url: '/assets/img/testimonial/testi_3_1.png',
                testimonial_text: 'A home that perfectly blends sustainability with luxury until discovered Ecoland Residence. The moment I stepped community, I knew it was where I wanted to live.',
            },
            {
                id: 'fallback-2',
                customer_name: 'Maria Doe',
                customer_title: 'Traveller',
                customer_image_url: '/assets/img/testimonial/testi_3_2.png',
                testimonial_text: 'The home boasts sleek, contemporary architecture with clean lines and expansive windows, allowing natural light to flood the interiors It incorporates passive design principles',
            },
            {
                id: 'fallback-3',
                customer_name: 'Angelina Rose',
                customer_title: 'Traveller',
                customer_image_url: '/assets/img/testimonial/testi_3_3.png',
                testimonial_text: 'Solar panels adorn the roof, harnessing renewable energy to power the home and even feed excess electricity back into the grid. High-performance insulation and triple-glazed',
            }
        ];
    };

    // Function to get image URL with fallback
    const getImageUrl = (testimonial, fallbackPath) => {
        return testimonial.customer_image_url || fallbackPath || '/assets/img/testimonial/testi_3_1.png';
    };

    return (
        <section className="testi-area3 bg-bottom-center overflow-hidden space" id="testi-sec"
            style={{ backgroundImage: "url(/assets/img/bg/map.png)", backgroundRepeat:"no-repeat" }}>
            <div className="container">
                <div className="title-area text-center">
                    <span className="sub-title">Testimonials</span>
                    <h2 className="sec-title">Our Clients Feedback</h2>
                </div>
                {loading ? (
                    <div className="text-center">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div className="row justify-content-center">
                        <div className="col-xl-12">
                            {/* Main Swiper */}
                            <Swiper
                                modules={[Pagination, Thumbs]}
                                slidesPerView={1}
                                loop={testimonials.length > 1}
                                speed={1800}
                                autoplay={{ delay: 3000, disableOnInteraction: false }}
                                pagination={{ clickable: true }}
                                thumbs={{ swiper: thumbsSwiper }}
                                className="th-slider testiSlide3 z-index-3"
                            >
                                {testimonials.map((testimonial, index) => (
                                    <SwiperSlide key={testimonial.id || `testimonial-${index}`}>
                                        <div className="testi-grid">
                                            <div className="testi-grid_author">
                                                <img 
                                                    src={getImageUrl(testimonial, `/assets/img/testimonial/testi_3_${(index % 6) + 1}.png`)}
                                                    alt={testimonial.customer_name}
                                                    onError={(e) => {
                                                        e.target.src = '/assets/img/testimonial/testi_3_1.png';
                                                    }}
                                                />
                                            </div>
                                            <div className="testi-grid_content">
                                                <p className="testi-grid_text">
                                                    "{testimonial.testimonial_text}"
                                                </p>
                                                <h6 className="testi-grid_name box-title">{testimonial.customer_name}</h6>
                                                <span className="testi-grid_desig">{testimonial.customer_title}</span>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                )}
            </div>
            {/* Thumbs Swiper */}
            {!loading && testimonials.length > 1 && (
                <Swiper
                    modules={[Thumbs]}
                    slidesPerView={Math.min(6, testimonials.length)}
                    spaceBetween={7}
                    loop={testimonials.length > 6}
                    onSwiper={setThumbsSwiper}
                    className="th-slider testi-grid-thumb shape-mockup-wrap"
                >
                    {testimonials.map((testimonial, index) => (
                        <SwiperSlide key={testimonial.id || `thumb-${index}`}>
                            <div className="box-img">
                                <img 
                                    src={getImageUrl(testimonial, `/assets/img/testimonial/testi_3_${(index % 6) + 1}.png`)}
                                    alt={testimonial.customer_name}
                                    onError={(e) => {
                                        e.target.src = '/assets/img/testimonial/testi_3_1.png';
                                    }}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                <div className="shape-mockup movingX d-none d-xl-block"
                    style={{
                        top: "0%",
                        left: "5%",
                    }}
                >
                    <img className="gmovingX" src="/assets/img/shape/shape_7.png" alt="shape" />
                </div>
                <div className="shape-mockup spin d-none d-xl-block"
                    style={{
                        bottom: "25%",
                        right: "5%",
                    }}
                >
                    <img src="/assets/img/shape/shape_2_5.png" alt="shape" />
                </div>
                <div className="shape-mockup jump d-none d-xl-block"
                    style={{
                        bottom: "30%",
                        left: "5%",
                    }}
                >
                    <img src="/assets/img/shape/shape_2_2.png" alt="shape" />
                </div>
                </Swiper>
            )}
        </section>
    );
}

const testimonials = [
    {
        image: "/assets/img/testimonial/testi_3_1.png",
        text: "“A home that perfectly blends sustainability with luxury until discovered Ecoland Residence. The moment I stepped community, I knew it was where I wanted to live.”",
        name: "Andrew Simon",
        designation: "Traveller",
    },
    {
        image: "/assets/img/testimonial/testi_3_2.png",
        text: "“The home boasts sleek, contemporary architecture with clean lines and expansive windows, allowing natural light to flood the interiors It incorporates passive design principles”",
        name: "Maria Doe",
        designation: "Traveller",
    },
    {
        image: "/assets/img/testimonial/testi_3_3.png",
        text: "“Solar panels adorn the roof, harnessing renewable energy to power the home and even feed excess electricity back into the grid. High-performance insulation and triple-glazed”",
        name: "Angelina Rose",
        designation: "Traveller",
    },
    {
        image: "/assets/img/testimonial/testi_3_4.png",
        text: "A sophisticated rainwater harvesting system collects and filters rainwater for irrigation and non-potable uses, reducing reliance on municipal water sources. Greywater systems",
        name: "Michel Carlos",
        designation: "Traveller",
    },
    {
        image: "/assets/img/testimonial/testi_3_5.png",
        text: "Throughout the interior, eco-friendly materials like reclaimed wood, bamboo flooring, and recycled glass countertops create a luxurious yet sustainable ambiance.",
        name: "Michel Smith",
        designation: "Traveller",
    },
    {
        image: "/assets/img/testimonial/testi_3_6.png",
        text: "“A home that perfectly blends sustainability with luxury until discovered Ecoland Residence. The moment I stepped community, I knew it was where I wanted to live.”",
        name: "Jesmen",
        designation: "Traveller",
    },
];

export default TestimonialThree;
